let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ld712")).then(() => parcelRequire('51PZj'));